import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: 'dropdownFilter',
  standalone: true
})
export class DropdownFilerPipe implements PipeTransform {

  transform(data: any[] | null, key: string, searchKey: string): any[] {
    if (!data) return [];

    if (!searchKey) {
      return data;
    }

    const normalizedSearch = searchKey.toLowerCase();

    return data.filter(ele => {
      const value = this.resolvePath(ele, key);
      if (value == null) return false;
      return String(value).toLowerCase().includes(normalizedSearch);
    });
  }

  /**
   * Resolves a possibly nested key on an object.
   * Supports both flat keys ('name') and dot-notation nested keys ('name.en').
   */
  private resolvePath(obj: any, path: string): any {
    return path
      .split('.')
      .reduce((acc, k) => (acc == null ? acc : acc[k]), obj);
  }
}